export const equipmentSubcategories = ['Weapon', 'Chest', 'Head', 'Arm', 'Leg'] as const;
export const nonEquipmentSubcategories = [
  'Food',
  'Beverage',
  'Summon',
  'Material',
  'Special',
] as const;
